import { Component, OnInit } from '@angular/core';
import { SidebarConfiguration } from '../../../models/sidebar-configuration';
import { SidebarService } from '../../../services/menu/sidebar.service';
import { MenuItem } from 'primeng/api';
import { PanelMenuModule } from 'primeng/panelmenu';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'app-user-management',
  standalone: true,
  imports: [PanelMenuModule, CardModule],
  templateUrl: './user-management.component.html',
  styleUrl: './user-management.component.scss',
})
export class UserManagementComponent implements OnInit {
  sidebarConfig: SidebarConfiguration = {
    cssClasses: 'w-screen',
    icon: 'fas fa-users',
    headerText: 'Nutzer:innen verwalten',
  };
  items: MenuItem[] = [];

  constructor(private sidebarService: SidebarService) {}

  /**
   * Lifecycle hook that is called after Angular has initialized all data-bound properties of a component.
   * This method sets up the sidebar configuration and initializes the panel menu.
   *
   * @return {void} Does not return a value.
   */
  ngOnInit(): void {
    this.sidebarService.setConfiguration(this.sidebarConfig);
    this.buildPanelMenu();
  }

  /**
   * Builds and sets up the panel menu by defining menu items with their respective labels, icons, and routing links.
   *
   * @return {void} Does not return a value.
   */
  buildPanelMenu(): void {
    this.items = [
      {
        label: 'Kommune',
        icon: 'fas fa-tree-city',
        routerLink: [{ outlets: { panel: 'kommune' } }],
      },
      {
        label: 'Nutzer:innen',
        icon: 'fas fa-users',
        routerLink: [{ outlets: { panel: 'nutzer' } }],
      },
      {
        label: 'Rollen',
        icon: 'fas fa-user-shield',
        routerLink: [{ outlets: { panel: 'rollen' } }],
      },
      {
        label: 'Arbeitsbereiche',
        icon: 'fas fa-users-viewfinder',
        routerLink: [
          { outlets: { panel: ['workspaces', 'indikatoren-bereiche'] } },
        ],
      },
    ];
  }
}
